import React from "react";
import "./Dashboard.css";
import { BookOpen, LayoutDashboard, Book, DollarSign, User, LogOut } from "lucide-react";
import { useAppContext } from "../../context/AppContext/AppContext";
import { auth } from "../../utils/firebase";
import { useNavigate } from "react-router-dom";

const courses = [
  { title: "Course: Computer Basics - Fundamental of Computers", totalClasses: 48 },
  //   { title: "Student Credits", credits: 7 },
  //   { title: "Data Structures", credits: 100 },
];

const chapters = [
  { title: "Introduction to Computers & Input Devices", status: "done" },
  { title: "Parts of a Computer - Output and Storage Devices", status: "done" },
  { title: "Hardware & CPU", status: "done" },
  { title: "Computer Software", status: "done" },
  { title: "Input & Output Cycle", status: "done" },
  { title: "Scratch Lesson 1", status: "done" },
  { title: "Scratch Lesson 2", status: "done" },
  { title: "Scratch Lesson 3", status: "done" },
  { title: "More on Keyboard Part 1", status: "done" },

];

const statusColor = {
  done: "status-done",
  inprogress: "status-inprogress",
  pending: "status-pending",
};



export default function Dashboard() {
  const navigate = useNavigate();


  const handleLogout = () => {
    try {
      auth.signOut();
      navigate("/login");
    } catch (error) {
      console.error("Logout error:", error.message);
      alert("An error occurred while logging out");

    }
  }

  return (
    <div className="dashboard-container">

      {/* Main Content */}
      <main className="main-content">
        <h1 className="main-title">Welcome Jianshi</h1>

        {/* Cards */}
        <div className="card-grid">
          <div className="course-card">
            <h3>Course</h3>
            <div className="d-flex gap-3">
              <p className="total_credits" >Computer Basics - Fundamental of Computers</p>
            </div>
          </div>

          <div className="course-card">
            <h3>Student Credits</h3>
            <div className="d-flex gap-3">
              <p className="total_credits" >Total Credits: <span>7</span></p>
              <p className="remaining_credits">Remaining Credits: <span>-2</span></p>
            </div>
          </div>

          <div className="course-card">
            <h3>Class Link</h3>
            <div className="d-flex gap-3">
              {/* <p className="total_credits" > Link</p> */}
              <p className="remaining_credits"><a href="https://meet.google.com/nxh-fwwd-zue" style={{ color: "blue" }}>https://meet.google.com/nxh-fwwd-zue</a></p>
            </div>
          </div>

        </div>

        {/* Chapters */}
        <div className="chapters-section">
          <h2 className="chapters-title">Course Chapters</h2>
          <ul className="chapters-list">
            {chapters.map((chapter, index) => (
              <li key={index} className="chapter-item">
                <div className="chapter-info">
                  <BookOpen className="chapter-icon" />
                  <span>{chapter.title}</span>
                </div>
                <span className={`chapter-status ${statusColor[chapter.status]}`}>{chapter.status}</span>
              </li>
            ))}
          </ul>
        </div>
      </main>
    </div>
  );
}
